import ExpenseCategoriesProxy from '@/proxies/Cashier/ExpenseCategoriesProxy';

export default {
  data() {
    return {
      useNullableExpensesCategory: true,
      categories: [],
    };
  },
  mounted() {
    this.getExpenseCategories();
  },
  computed: {
    expenseCategoryItems() {
      const list = [];
      if (this.useNullableExpensesCategory) {
        list.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      for (const category of this.categories) {
        list.push({
          text: category.name,
          value: category.id,
        });
      }
      return list;
    },
  },
  methods: {
    getExpenseCategories() {
      new ExpenseCategoriesProxy()
        .setParameters({})
        .all()
        .then((response) => {
          this.categories = response.data.data.categories;
          this.$forceUpdate();
          // console.log(response.data.data.categories);
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
